export default __webpack_public_path__ + "static/conceptionCardBackground-89342a422b3482624691afcd266ea903.png";